import { defineMessages } from 'react-intl';
import type { NoMessageValues, MessageValue } from 'react-intl';

export const CategoryMessages = defineMessages<{
  readonly clearSelection: NoMessageValues;
  readonly itemsQuantity: { readonly count: MessageValue };
}>({
  clearSelection: {
    id: 'search.filters.category.clearSelection',
    defaultMessage: 'Auswahl aufheben',
  },
  itemsQuantity: {
    id: 'search.filters.category-itemsQuantity',
    defaultMessage: 'Anzahl der Artikel: {count}',
  },
});
